import Head from 'next/head'
import Layout, { Breadcrumb } from 'components/layout'
import { Container, Button, Link } from 'components/ui'
import { useRouter } from 'next/router'
import { useUserSession } from 'hooks'
import s from './index.module.css'

export default function ProgramaAfiliados() {
  const router = useRouter()
  const { isLoggedIn } = useUserSession()

  const crums = [
    {
      label: 'Institucional',
    },
  ]

  const handleStartNow = () => {
    if (!isLoggedIn) {
      router.push('/entrar?from=/cadastro-afiliados')
    } else {
      router.push('/cadastro-afiliados')
    }
  }

  return (
    <Layout>
      <Head>
        <title>Programa de Afiliados - Parceiros da Colheita | Fazendinha em Casa</title>
      </Head>
      <Breadcrumb crumbs={crums} />
      <div className={s.programa_afiliados}>
        <Container className={s.root}>
          <div className={s.top_banner}>
            <img src="/assets/images/banners/banner-afiliados.jpg" alt="" />
          </div>

          <div className={s.header_content}>
            <h1 className={s.title}>
              Seja um afiliado do Programa Parceiros da Colheita e colha recompensas com propósito!
            </h1>
            <p className={s.subtitle}>
              Ganhe uma renda extra promovendo alimentos saudáveis, produzidos com carinho por pequenos produtores e entregues com cuidado pela Fazendinha em Casa.
            </p>
            <Button onClick={handleStartNow} variant="primary" className={s.header_button}>
              Quero ser um Parceiro da Colheita
            </Button>
          </div>

          <section className={s.section}>
            <h2 className={s.text__h1}>O que é o Programa de Afiliados Parceiros da Colheita?</h2>
            <div className={s.what_is_content}>
              <p className={s.what_is_text}>
                Você acredita em uma alimentação mais consciente, saudável e feita com afeto? O programa Parceiros da Colheita é para você!
              </p>
              <p className={s.what_is_text}>
                Criamos uma rede de pessoas que compartilham os mesmos valores da Fazendinha em Casa e desejam gerar impacto positivo, enquanto conquistam uma renda extra. Você se torna nosso parceiro(a), indica os produtos para sua rede e recebe comissões pelas compras realizadas.
              </p>
              <p className={s.what_is_text}>
                É simples, humano e feito para quem deseja unir propósito com oportunidade.
              </p>
            </div>
          </section>

          <nav className={s.nav}>
            <ul>
              <li>
                <div className={s.nav_icon}>💰</div>
                <div className={s.nav_text}>
                  <h3>COMISSÕES JUSTAS</h3>
                  <p>Ganhe mais por resultado alcançado</p>
                </div>
              </li>
              <li>
                <div className={s.nav_icon}>⏰</div>
                <div className={s.nav_text}>
                  <h3>FLEXIBILIDADE</h3>
                  <p>Venda no seu tempo</p>
                </div>
              </li>
              <li>
                <div className={s.nav_icon}>💬</div>
                <div className={s.nav_text}>
                  <h3>SUPORTE</h3>
                  <p>Conte com nossa equipe</p>
                </div>
              </li>
              <li>
                <div className={s.nav_icon}>📱</div>
                <div className={s.nav_text}>
                  <h3>MATERIAIS</h3>
                  <p>Conteúdo pronto para usar</p>
                </div>
              </li>
            </ul>
          </nav>

          <section className={s.section}>
            <h2 className={s.text__h1}>Como funciona?</h2>
            <div className={s.steps}>
              <div className={s.step}>
                <div className={s.step_number}>1</div>
                <div className={s.step_content}>
                  <h3>Cadastre-se</h3>
                  <p>Cadastre-se como cliente em nosso site com seus dados pessoais. Se você já é cliente, é só completar com os dados específicos de afiliado.</p>
                </div>
              </div>
              <div className={s.step}>
                <div className={s.step_number}>2</div>
                <div className={s.step_content}>
                  <h3>Leia os termos</h3>
                  <p>Leia os termos de uso e dê o seu de acordo.</p>
                </div>
              </div>
              <div className={s.step}>
                <div className={s.step_number}>3</div>
                <div className={s.step_content}>
                  <h3>Dados bancários</h3>
                  <p>Preencha o formulário com seus dados bancários para recebimento dos créditos.</p>
                </div>
              </div>
              <div className={s.step}>
                <div className={s.step_number}>4</div>
                <div className={s.step_content}>
                  <h3>Redes sociais</h3>
                  <p>É necessário que suas redes sociais sejam públicas.</p>
                </div>
              </div>
              <div className={s.step}>
                <div className={s.step_number}>5</div>
                <div className={s.step_content}>
                  <h3>Crie sua página</h3>
                  <p>Crie sua página personalizada de afiliado destacando os produtos de parceiros Fazendinha que você preferir.</p>
                </div>
              </div>
              <div className={s.step}>
                <div className={s.step_number}>6</div>
                <div className={s.step_content}>
                  <h3>Link exclusivo</h3>
                  <p>Receba seu link exclusivo da sua página de afiliado.</p>
                </div>
              </div>
              <div className={s.step}>
                <div className={s.step_number}>7</div>
                <div className={s.step_content}>
                  <h3>Aprovação</h3>
                  <p>Após a aprovação do seu cadastro, é só começar a divulgá-la.</p>
                </div>
              </div>
              <div className={s.step}>
                <div className={s.step_number}>8</div>
                <div className={s.step_content}>
                  <h3>Compartilhe</h3>
                  <p>Compartilhe com sua rede: amigos, pacientes, seguidores e clientes.</p>
                </div>
              </div>
              <div className={s.step}>
                <div className={s.step_number}>9</div>
                <div className={s.step_content}>
                  <h3>Acompanhe vendas</h3>
                  <p>Acompanhe as vendas com facilidade e transparência na área do afiliado.</p>
                </div>
              </div>
              <div className={s.step}>
                <div className={s.step_number}>10</div>
                <div className={s.step_content}>
                  <h3>Receba comissões</h3>
                  <p>Receba mensalmente seus créditos relativos aos pedidos pagos gerados.</p>
                </div>
              </div>
            </div>
            <div className={s.steps_note}>
              <p>Você recebe acesso a diversos conteúdos de apoio, dicas de vendas e pode contar com o nosso suporte durante toda a sua jornada.</p>
            </div>
            <div style={{ textAlign: 'center', marginTop: 32 }}>
              <Button onClick={handleStartNow} className={s.cta_button}>
                Quero ser um Parceiro da Colheita
              </Button>
            </div>
          </section>

          <section className={s.section}>
            <h2 className={s.text__h1}>Por que participar?</h2>
            <div className={s.benefits_grid}>
              <div className={s.benefit_card}>
                <div className={s.benefit_icon}>🌱</div>
                <h3>Produtos Artesanais</h3>
                <p>Produtos artesanais, locais e de alta qualidade</p>
              </div>
              <div className={s.benefit_card}>
                <div className={s.benefit_icon}>💸</div>
                <h3>Comissões Justas</h3>
                <p>Comissões justas e pagas mensalmente</p>
              </div>
              <div className={s.benefit_card}>
                <div className={s.benefit_icon}>⏰</div>
                <h3>Trabalho Flexível</h3>
                <p>Trabalho flexível: você vende no seu tempo, de onde estiver</p>
              </div>
              <div className={s.benefit_card}>
                <div className={s.benefit_icon}>🤝</div>
                <h3>Suporte Completo</h3>
                <p>Acompanhamento e suporte do nosso time</p>
              </div>
              <div className={s.benefit_card}>
                <div className={s.benefit_icon}>📱</div>
                <h3>Materiais Prontos</h3>
                <p>Materiais prontos para facilitar a sua divulgação</p>
              </div>
              <div className={s.benefit_card}>
                <div className={s.benefit_icon}>🔄</div>
                <h3>Clientes Fidelizados</h3>
                <p>Clientes fidelizados e alto índice de recompra</p>
              </div>
              <div className={s.benefit_card}>
                <div className={s.benefit_icon}>❤️</div>
                <h3>Impacto Positivo</h3>
                <p>Você ajuda a valorizar o pequeno produtor e levar saúde à mesa das pessoas</p>
              </div>
            </div>
          </section>

          <section className={s.section}>
            <h2 className={s.text__h1}>Para quem é?</h2>
            <div className={s.target_intro}>
              <p>O Parceiros da Colheita é ideal para quem quer ir além da venda — e fazer parte de uma causa. Se você é:</p>
            </div>
            <div className={s.target_grid}>
              <div className={s.target_card}>
                <div className={s.target_icon}>👨‍⚕️</div>
                <h3>Profissionais da Saúde</h3>
                <p>Nutricionista ou profissional da saúde que deseja indicar produtos confiáveis</p>
              </div>
              <div className={s.target_card}>
                <div className={s.target_icon}>📱</div>
                <h3>Criadores de Conteúdo</h3>
                <p>Criador(a) de conteúdo ligado à alimentação, bem-estar ou vida saudável</p>
              </div>
              <div className={s.target_card}>
                <div className={s.target_icon}>❤️</div>
                <h3>Clientes Fieis</h3>
                <p>Cliente fiel da Fazendinha em Casa que ama os nossos produtos</p>
              </div>
              <div className={s.target_card}>
                <div className={s.target_icon}>🌍</div>
                <h3>Entusiastas</h3>
                <p>Entusiasta da alimentação natural, da sustentabilidade e do comércio justo</p>
              </div>
            </div>
            <div className={s.target_outro}>
              <p>Você já tem o perfil certo para participar!</p>
            </div>
          </section>

          <section className={s.cta_section}>
            <h2 className={s.cta_title}>Comece agora</h2>
            <p className={s.cta_text}>
              Pronto para colher bons frutos com a gente? Clique no botão abaixo, preencha seu cadastro e junte-se ao programa Parceiros da Colheita.
            </p>
            <Button onClick={handleStartNow}  className={s.cta_button}>
              Quero ser um Parceiro da Colheita
            </Button>
          </section>

          <section className={s.section}>
            <h2 className={s.text__h1}>Ficou com alguma dúvida?</h2>
            <div className={s.contact_grid}>
              <div className={s.contact_card}>
                <div className={s.contact_icon}>💬</div>
                <h3>WhatsApp</h3>
                <p>
                  Fale com a gente pelo{' '}
                  <Link
                    href={`https://api.whatsapp.com/send?phone=5531982404927`}
                    newTab
                    className={s.whatsapp_link}
                  >
                    (31) 98240-4927
                  </Link>
                </p>
              </div>
              <div className={s.contact_card}>
                <div className={s.contact_icon}>📱</div>
                <h3>Redes Sociais</h3>
                <div className={s.socialLinks}>
                  <Link href="https://www.instagram.com/fazendinhaemcasa/" newTab>
                    Instagram
                  </Link>
                  <Link href="https://www.facebook.com/fazendinhaemcasa" newTab>
                    Facebook
                  </Link>
                  <Link href="https://www.tiktok.com/@fazendinhaemcasa" newTab>
                    TikTok
                  </Link>
                  <Link href="https://www.youtube.com/@fazendinhaemcasa" newTab>
                    YouTube
                  </Link>
                </div>
              </div>
            </div>
          </section>
        </Container>
      </div>
    </Layout>
  )
}
